/**
 * useAuth Hook
 *
 * Simple context consumer for AuthContext.
 * Throws if used outside an AuthProvider.
 *
 * Requirements: 4.2
 */

import { useAuthContext } from '@/context/AuthContext';
import type { AuthContextValue } from '@/context/AuthContext';

export function useAuth(): AuthContextValue {
  return useAuthContext();
}
